import type { ReactNode } from "react";

import { DotLegalStep } from "@/features/search/components/badge-legal-step";

import type { ClaimLegalStepName } from "../../lib/legal-steps";

interface CtaShellProps {
  legalStepName: ClaimLegalStepName;
  title?: string;
  children: ReactNode;
  /** Overrides the max-w-lg default (e.g. max-w-xl for MergeAssignationCTA). */
  maxWidthClassName?: string;
}

/** Common shell of the states-cta panels — border-b bg-slate-50 → white card « Actions requises ». */
export function CtaShell({
  legalStepName,
  title = "Actions requises",
  children,
  maxWidthClassName = "max-w-lg",
}: CtaShellProps) {
  return (
    <div className="border-b bg-slate-50">
      <div className={`mx-auto py-5 text-left ${maxWidthClassName}`}>
        <div className="rounded-md border bg-white p-8 shadow">
          <h2 className="inline-flex align-middle text-base leading-6 font-semibold text-gray-900">
            <div className="mr-2 py-1">
              <DotLegalStep name={legalStepName} />
            </div>
            {title}
          </h2>
          {children}
        </div>
      </div>
    </div>
  );
}
